import { createTeleTechnicianWorkApiClient } from "../ApiClientFactory";
import { genericErrorMessage } from "../serviceNowLink";

export const deleteWork = async (id: string) => {
  try {
    await createTeleTechnicianWorkApiClient().works.deleteApiWorks(id);
  } catch (err) {
    throw new Error(`Linjen kunne ikke slettes. ${genericErrorMessage}`);
  }
};